export enum UnitPinStatus {
  NotSet,
  Set,
}
